"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { ChatConversation, ChatMessage } from "@/lib/chatbot/api";

type ChatbotState = {
  open: boolean;
  pending: boolean;
  error: string | null;
  lastQuestion: string | null;
  unsaved: boolean;
  historyLoading: boolean;
  branchKey: string;
  conversationId: string | null;
  conversationByBranch: Record<string, string>;
  conversations: ChatConversation[];
  listCursor: string | null;
  messages: ChatMessage[];
  messagesCursor: string | null;
  setOpen: (open: boolean) => void;
  newChat: () => void;
};

export const useChatbotStore = create<ChatbotState>()(
  persist(
    (set, get) => ({
      open: false,
      pending: false,
      error: null,
      lastQuestion: null,
      unsaved: false,
      historyLoading: false,
      branchKey: "",
      conversationId: null,
      conversationByBranch: {},
      conversations: [],
      listCursor: null,
      messages: [],
      messagesCursor: null,
      setOpen: (open) => set({ open }),
      newChat: () => {
        const { messages, conversationId, branchKey, conversationByBranch } =
          get();
        const nextMap = { ...conversationByBranch };
        delete nextMap[branchKey];
        if (messages.length === 0 && !conversationId) {
          set({
            error: null,
            pending: false,
            lastQuestion: null,
            unsaved: false,
            historyLoading: false,
            conversationByBranch: nextMap,
          });
          return;
        }
        set({
          conversationId: null,
          messages: [],
          messagesCursor: null,
          error: null,
          pending: false,
          lastQuestion: null,
          unsaved: false,
          historyLoading: false,
          conversationByBranch: nextMap,
        });
      },
    }),
    {
      name: "admin-chatbot-conversation",
      partialize: (state) => ({
        conversationByBranch: state.conversationByBranch,
      }),
    },
  ),
);
